import React from "react";
import Image from "gatsby-image/withIEPolyfill";
import { useStaticQuery, graphql } from "gatsby";

const GatsbyImage = ({ className, filename, style, alt }) => {
  const data = useStaticQuery(graphql`
    query {
      allImageSharp {
        edges {
          node {
            fluid(maxWidth: 3080, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  `);

  const image = data.allImageSharp.edges.find((file) =>
    file.node.fluid.src.includes(filename)
  ).node.fluid;

  return (
    <>
      {image && (
        <Image className={className} alt={alt} fluid={image} style={style} />
      )}
    </>
  );
};

export default GatsbyImage;
